import { apiFetch } from '../../../shared/services/apiClient';
import { Ciudad, Departamento } from '../types';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:4000/api';

export const ubicacionService = {
  async listarDepartamentos(): Promise<Departamento[]> {
    const res = await apiFetch(`${API_BASE}/departamentos`);
    if (!res.ok) throw new Error('Error cargando departamentos');
    return res.json();
  },

  async listarCiudades(departamentoId: number): Promise<Ciudad[]> {
    const res = await apiFetch(`${API_BASE}/ciudades?departamentoId=${departamentoId}`);
    if (!res.ok) throw new Error('Error cargando ciudades');
    return res.json();
  },
};
